import { createSelector } from 'reselect'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.RICH_TEXT_STUDENT_SESSION,
])

const pollSelector = state => state.poll

const creationToolContainerSelector = createSelector(
	[ pollSelector, featureFlagsSelector],
	(pollState, featureFlags) => ({
		...pollState,
		shouldShowHTMLComponent: featureFlags[featureFlagsTypes.RICH_TEXT_STUDENT_SESSION],
	})
)

export default creationToolContainerSelector
